import React, { useState, useEffect } from "react";
import {
    Avatar,
    Box,
    Button,
    Grid2,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    FormHelperText,
    FormControlLabel,
    Checkbox,
    Grid,
    Modal,
    Fade,
    IconButton,
    Typography,
} from "@mui/material";
import Header from "../Header/Header";
import TextField from "@mui/material/TextField";
import consts from "../../constant";
import Axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import toast, { Toaster } from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import "./Staking.css";
import { ToastContainer } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = 260;


const EditAdminAction = () => {
    const token = localStorage.getItem("adminToken");
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const detail = useLocation();
    const [reason, setReason] = useState();
    const [reasons, setReasons] = useState(false);
    const Navigate = useNavigate();
    const back = useNavigate();


    const navigate = useNavigate();
    const location = useLocation();

    const editStatus = location?.state?.value;

    const [selectedDurations, setSelectedDurations] = useState([]);
    const [amount, setAmount] = useState("");
    const [twentyPercent, setTwentyPercent] = useState("");
    const [tjrmPrice, setTjrmPrice] = useState("");
    const [tokenWorth, setTokenWorth] = useState("");
    const [status, setStatus] = useState(false);

    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm();

    // ✅ Handle Amount Change and calculate 20%
    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);

        const twenty = parseFloat(value) * 0.2;
        setTwentyPercent(twenty.toFixed(2));

        if (tjrmPrice) {
            const worth = twenty / parseFloat(tjrmPrice);
            setTokenWorth(worth.toFixed(2));
        }
    };

    // ✅ Handle TJRM Price Change and calculate Token Worth
    const handleTjrmPriceChange = (e) => {
        const value = e.target.value;
        setTjrmPrice(value);

        if (twentyPercent) {
            const worth = parseFloat(twentyPercent) / parseFloat(value);
            setTokenWorth(worth.toFixed(2));
        }
    };

    // ✅ Handle Checkbox Selection
    const handleCheckboxChange = (event) => {
        const value = event.target.value;
        setSelectedDurations((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value)
                : [...prev, value]
        );
    };

    // ✅ Handle Form Submission
    const onSubmit = async (data) => {
        try {
            const payload = {
                id: editStatus?._id,
                type: data?.type,
                price: amount,
                tjrmPrice: tjrmPrice,
                twentyPercent: twentyPercent,
                tokenWorth: tokenWorth,
                durations: selectedDurations,
                status: data?.status,
            };

            const response = await Axios.post(
                `${consts.BackendUrl}/staking/editAdminStak`,
                payload,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (response.data.success) {
                toast.success(response.data.message || "Successfully Updated!");
                navigate(`/${consts.route}/stakingHistory`);
            } else {
                toast.error(response.data.message || "An unexpected error occurred.");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong!");
        }
    };

    // ✅ Pre-fill Form Data when in Edit Mode
    useEffect(() => {
        if (editStatus) {
            setValue("type", editStatus.type);
            setAmount(editStatus.price);
            setTjrmPrice(editStatus.tjrmPrice);
            setTwentyPercent(editStatus.twentyPercent);
            setTokenWorth(editStatus.tokenWorth);
            setSelectedDurations(editStatus.durations);
            setStatus(editStatus.status);
        }
    }, [editStatus]);

    return (
        <div className="UserList create-asset">
            <ToastContainer />
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid2 container spacing={2}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <div className="d-flex align-fe">
                                    <Button
                                        className="Backbutton"
                                        variant="contained"
                                        onClick={() => {
                                            back(`/${consts.route}/stakingHistory`);
                                        }}
                                    >
                                        Back
                                    </Button>
                                </div>

                                <div className="custom_table p-10">
                                    <Grid2
                                        container
                                        spacing={0}
                                        style={{ height: "100%" }}
                                        alignItems={"center"}
                                    >
                                        <Grid2
                                            item
                                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                            sx={{
                                                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                    color: "white",
                                                },
                                            }}
                                        >


                                            <div className="view-inp p-10">
                                                <div className="txt-white">Type</div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="type"
                                                        control={control}
                                                        defaultValue={editStatus?.type}
                                                        rules={{ required: "Type is required" }}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth>
                                                                <Select {...field}>
                                                                    <MenuItem value="profit">Profit (+)</MenuItem>
                                                                    <MenuItem value="loss">Loss (-)</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                    {errors.type && <p className="err">{errors.type.message}</p>}
                                                    {errors.type && (
                                                        <p className="err">{errors?.type?.message}</p>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="view-inp p-10">
                                                <div className="txt-white">Status</div>
                                                <div className="mt-10">
                                                    <Controller
                                                        name="status"
                                                        control={control}
                                                        defaultValue={editStatus?.status}
                                                        render={({ field }) => (
                                                            <FormControl fullWidth>
                                                                <Select {...field}>
                                                                    <MenuItem value={true}>True</MenuItem>
                                                                    <MenuItem value={false}>False</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    />
                                                    {errors.type && <p className="err">{errors.type.message}</p>}
                                                </div>
                                            </div>


                                            <div>
                                                {/* Amount Input */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">Admin Total Revenue</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            {...register("price", { required: "Price is required" })}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={amount}
                                                            onChange={handleAmountChange}
                                                        />
                                                        <p className="err">{errors?.price?.message}</p>
                                                    </div>
                                                </div>

                                                {/* 20% of Amount */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">20% of Revenue</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={twentyPercent}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* TJRM Current Price Input */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white"> 1 TJRM  Current Price</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            {...register("tjrmPrice", { required: "Tjrm current Price" })}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={tjrmPrice}
                                                            onChange={handleTjrmPriceChange}
                                                        />
                                                        <p className="err">{errors?.tjrmPrice?.message}</p>
                                                    </div>
                                                </div>

                                                {/* Token Worth */}
                                                <div className="view-inp p-10">
                                                    <div className="txt-white">Distribution Amount (Token Worth)</div>
                                                    <div className="mt-10">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            type="number"
                                                            fullWidth
                                                            value={tokenWorth}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </Grid2>

                                    </Grid2>
                                    <Grid container spacing={2} className="p-10">
                                        {/* Title */}
                                        <Grid item xs={12}>
                                            <div style={{ color: "white" }} className="text-white mb-2">
                                                Select Staking Plan to be Update
                                            </div>
                                        </Grid>

                                        {/* Staking Duration Options */}
                                        <Grid item xs={12}>
                                            <Grid container spacing={2}>
                                                {["3", "6", "9", "12"].map((duration) => (
                                                    <Grid item xs={4} key={duration}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    sx={{
                                                                        color: "#fff",
                                                                        "&.Mui-checked": { color: "#fff" },
                                                                        "&.Mui-checked:hover": { color: "#fff" },
                                                                        "&.Mui-checked:focus": { color: "#fff" },
                                                                        "&.Mui-checked.Mui-disabled": { color: "#fff" },
                                                                        //  font color ehite
                                                                        "&.Mui-disabled": { color: "#fff" },
                                                                    }}
                                                                    checked={selectedDurations.includes(duration)}
                                                                    onChange={handleCheckboxChange}
                                                                    value={duration}
                                                                />
                                                            }
                                                            //  this label color white 
                                                            sx={{ color: "#fff" }}
                                                            label={`${duration} Months`}
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{ margin: "20px 10px", padding: "8px 40px" }}
                                    >
                                        update
                                    </Button>

                                </div>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>
            </Box>
            <Toaster />

        </div>
    );
};

export default EditAdminAction;
